import { Dress } from "./dress.model"

export class collection {
  constructor(public name: string, public dresses: Dress[],
    public description: string, public collectionPhoto: string){}
}
